import React from 'react';
import PropTypes from 'prop-types';
import { ToggleButton } from '@piplapps/pipl-ui';
import styles from './UpdatePermissionsModal.module.less';

const UpdatePermission = (props) => {
  const noAvailableSeats = props.availableSeats === 0;
  const lastSeat = noAvailableSeats && props.initialSearchStatus;

  return (
    <div className={styles.permissionsContainer}>
      <div className={styles.permissionContainer}>
        <div className={styles.toggleButton}>
          <ToggleButton
            onText="on"
            offText="off"
            checkStatus={props.adminPermissionStatus}
            switchChangeHandle={props.handleAdminToggle}
            disabled={props.isSelfUser}
            id="admin-toggle"
          />
        </div>

        <div className={styles.labelWrapper}>
          <strong>{gettext('Admin ')}</strong>
          {gettext(' - Manage users, billing and products.')}
        </div>
      </div>
      <div className={styles.permissionContainer}>
        <div className={styles.toggleButton}>
          <ToggleButton
            onText="on"
            offText="off"
            checkStatus={props.searchPermissionStatus}
            switchChangeHandle={props.handleSearchToggle}
            disabled={noAvailableSeats && !props.searchPermissionStatus && !lastSeat}
            id="search-toggle"
          />
        </div>
        <div className={styles.labelWrapper}>
          {!props.isTrial ? (
            <>
              <strong>{gettext('Pipl Subscription')}</strong>
              {gettext(' - Access to Pipl products.')}
            </>
          ) : (
            <>
              <strong>{gettext('Pipl Subscription trial')}</strong>
              {gettext(' - Access to Pipl products.')}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

UpdatePermission.propTypes = {
  isTrial: PropTypes.bool,
  searchPermissionStatus: PropTypes.bool,
  adminPermissionStatus: PropTypes.bool,
  handleAdminToggle: PropTypes.func,
  handleSearchToggle: PropTypes.func,
  availableSeats: PropTypes.number,
  isSelfUser: PropTypes.bool,
  initialSearchStatus: PropTypes.bool,
};

export default UpdatePermission;
